import { LocalizedString } from 'osn-shared';
import { EditorialUcSelectFormData } from '../editorial-uc-select-form-control/editorial-uc-select-form-data';
import { TraySelectorType } from '../tray-selector/tray-selector.enum';
import { ViewModelCommon } from '../view-model-common/view-model-common';
import { TrayFormViewModelType } from '../view-model-common/view-model-type';

export type RecommendationTrayTypeVM =
  | TrayFormViewModelType.TopPicks
  | TrayFormViewModelType.TopPicksMovies
  | TrayFormViewModelType.TopPicksSeries
  | TrayFormViewModelType.BecauseYouWatched
  | TrayFormViewModelType.PeopleLikeYouWatch
  | TrayFormViewModelType.PeopleLikeYouWatchMovies
  | TrayFormViewModelType.PeopleLikeYouWatchSeries
  | TrayFormViewModelType.Trending // AXB-929
  | TrayFormViewModelType.TrendingMovies // AXB-930
  | TrayFormViewModelType.TrendingSeries // AXB-931
  | TrayFormViewModelType.TrendingWithLayout
  | TrayFormViewModelType.BecauseYouWatchGenreTray
  | TrayFormViewModelType.DontMiss
  | TrayFormViewModelType.PeopleLikeYouWatchDownloadable
  | TrayFormViewModelType.PeopleLikeYouWatchMoviesDownloadable
  | TrayFormViewModelType.PeopleLikeYouWatchSeriesDownloadable
  | TrayFormViewModelType.TopPicksDownloadable
  | TrayFormViewModelType.TopPicksMoviesDownloadable
  | TrayFormViewModelType.TopPicksSeriesDownloadable
  | TrayFormViewModelType.MostDownloadedMovies
  | TrayFormViewModelType.MostDownloadedSeries
  | TrayFormViewModelType.Editorial;

export enum RecommendationBecauseYouWatchedRecency {
  Latest = 'Latest',
  Second = '2nd latest',
  Third = '3rd latest',
}

export interface RecommendationTrayProgramData {
  availabilityFrom?: string;
  availabilityTo?: string;
  episode?: boolean;
  id: number;
  season?: boolean;
  title?: string;
}

export interface RecommendationCommonTrayFormViewModel extends ViewModelCommon {
  id?: string;
  title: LocalizedString;
  type: RecommendationTrayTypeVM;
  isKidsOnly: boolean;
  userSegmentIds: string[];
  countryIds: string[];
  layout: TraySelectorType;
  platformIds: string[];
}

export interface RecommendationBecauseYouWatchedTrayFormViewModel extends RecommendationCommonTrayFormViewModel {
  recency: RecommendationBecauseYouWatchedRecency;
  type: TrayFormViewModelType.BecauseYouWatched;
}

export interface RecommendationPeopleLikeYouWatchTrayFormViewModel extends RecommendationCommonTrayFormViewModel {
  type: TrayFormViewModelType.PeopleLikeYouWatch;
}

export interface RecommendationPeopleLikeYouWatchMoviesTrayFormViewModel extends RecommendationCommonTrayFormViewModel {
  type: TrayFormViewModelType.PeopleLikeYouWatchMovies;
}

export interface RecommendationPeopleLikeYouWatchSeriesTrayFormViewModel extends RecommendationCommonTrayFormViewModel {
  type: TrayFormViewModelType.PeopleLikeYouWatchSeries;
}

export interface RecommendationTopPicksTrayFormViewModel extends RecommendationCommonTrayFormViewModel {
  type: TrayFormViewModelType.TopPicks;
}

export interface RecommendationTopPicksMoviesTrayFormViewModel extends RecommendationCommonTrayFormViewModel {
  type: TrayFormViewModelType.TopPicksMovies;
}

export interface RecommendationTopPicksSeriesTrayFormViewModel extends RecommendationCommonTrayFormViewModel {
  type: TrayFormViewModelType.TopPicksSeries;
}

export interface RecommendationTrendingTrayFormViewModel extends RecommendationCommonTrayFormViewModel {
  type: TrayFormViewModelType.Trending;
}

export interface RecommendationTrendingMoviesTrayFormViewModel extends RecommendationCommonTrayFormViewModel {
  type: TrayFormViewModelType.TrendingMovies; // AXB-930
}

export interface RecommendationTrendingSeriesTrayFormViewModel extends RecommendationCommonTrayFormViewModel {
  type: TrayFormViewModelType.TrendingSeries; // AXB-931
}

export interface RecommendationTrendingWithLayoutTrayFormViewModel extends RecommendationCommonTrayFormViewModel {
  type: TrayFormViewModelType.TrendingWithLayout;
}

export interface RecommendationBecauseYouWatchGenreTrayFormViewModel extends RecommendationCommonTrayFormViewModel {
  recency: RecommendationBecauseYouWatchedRecency;
  type: TrayFormViewModelType.BecauseYouWatchGenreTray;
}

export interface RecommendationDontMissTrayFormViewModel extends RecommendationCommonTrayFormViewModel {
  type: TrayFormViewModelType.DontMiss;
}

export interface RecommendationPeopleLikeYouWatchDownloadableTrayFormViewModel extends RecommendationCommonTrayFormViewModel {
  type: TrayFormViewModelType.PeopleLikeYouWatchDownloadable;
}
export interface RecommendationPeopleLikeYouWatchMoviesDownloadableTrayFormViewModel extends RecommendationCommonTrayFormViewModel {
  type: TrayFormViewModelType.PeopleLikeYouWatchMoviesDownloadable;
}
export interface RecommendationPeopleLikeYouWatchSeriesDownloadableTrayFormViewModel extends RecommendationCommonTrayFormViewModel {
  type: TrayFormViewModelType.PeopleLikeYouWatchSeriesDownloadable;
}

export interface RecommendationTopPicksDownloadableTrayFormViewModel extends RecommendationCommonTrayFormViewModel {
  type: TrayFormViewModelType.TopPicksDownloadable;
}
export interface RecommendationTopPicksMoviesDownloadableTrayFormViewModel extends RecommendationCommonTrayFormViewModel {
  type: TrayFormViewModelType.TopPicksMoviesDownloadable;
}
export interface RecommendationTopPicksSeriesDownloadableTrayFormViewModel extends RecommendationCommonTrayFormViewModel {
  type: TrayFormViewModelType.TopPicksSeriesDownloadable;
}

export interface RecommendationMostDownloadedMoviesTrayFormViewModel extends RecommendationCommonTrayFormViewModel {
  type: TrayFormViewModelType.MostDownloadedMovies;
}

export interface RecommendationMostDownloadedSeriesTrayFormViewModel extends RecommendationCommonTrayFormViewModel {
  type: TrayFormViewModelType.MostDownloadedSeries;
}

export interface RecommendationEditorialTrayFormViewModel extends RecommendationCommonTrayFormViewModel {
  type: TrayFormViewModelType.Editorial;
  editorialUC: EditorialUcSelectFormData;
}

export type RecommendationTrayViewModel =
  | RecommendationTopPicksTrayFormViewModel
  | RecommendationTrendingTrayFormViewModel // AXB-929
  | RecommendationTrendingMoviesTrayFormViewModel // AXB-930
  | RecommendationTrendingSeriesTrayFormViewModel // AXB-931
  | RecommendationTrendingWithLayoutTrayFormViewModel // AXB-929
  | RecommendationBecauseYouWatchedTrayFormViewModel
  | RecommendationPeopleLikeYouWatchTrayFormViewModel
  | RecommendationPeopleLikeYouWatchMoviesTrayFormViewModel
  | RecommendationPeopleLikeYouWatchSeriesTrayFormViewModel
  | RecommendationBecauseYouWatchGenreTrayFormViewModel
  | RecommendationTopPicksSeriesTrayFormViewModel
  | RecommendationTopPicksMoviesTrayFormViewModel
  | RecommendationDontMissTrayFormViewModel
  | RecommendationPeopleLikeYouWatchDownloadableTrayFormViewModel
  | RecommendationPeopleLikeYouWatchMoviesDownloadableTrayFormViewModel
  | RecommendationPeopleLikeYouWatchSeriesDownloadableTrayFormViewModel
  | RecommendationTopPicksDownloadableTrayFormViewModel
  | RecommendationTopPicksMoviesDownloadableTrayFormViewModel
  | RecommendationTopPicksSeriesDownloadableTrayFormViewModel
  | RecommendationMostDownloadedMoviesTrayFormViewModel
  | RecommendationMostDownloadedSeriesTrayFormViewModel
  | RecommendationEditorialTrayFormViewModel;
